import { AuthenticationMethod } from './authentication-method.model'

export class AccountMFA {
  constructor(init: Partial<AccountMFA> = {}) {
    this.accountId = init.accountId || ''
    this.isMfaEnabled = init.isMfaEnabled ?? false
    this.isHighRiskUser = init.isHighRiskUser ?? false
    this.emailAddress = init.emailAddress || ''
    this.authenticationMethods = init.authenticationMethods || []
  }

  accountId: string
  isMfaEnabled: boolean
  isHighRiskUser: boolean
  emailAddress: string
  authenticationMethods: AuthenticationMethod[]
}
